import 'lbs-jqueryui/css/Leica/jquery-ui.css';

import $ from 'jquery';
import 'lbs-jqueryui';

// Knockout and other old code support
window.$ = $;
window.jQuery = $;



// WEBPACK FOOTER //
// ./src/lib/vendor/shared.js